export default () => {
    const homePage = document.querySelector(".type-index");

    if (homePage) {
        const products = document.querySelector('#products-2')
        $('.homepage-box.welcome-wrapper').insertAfter('.before-carousel')

        $('.homepage-products-heading-2').text('Produkty')
        $(products).after('<div class="text-center btn-all-products"><a href="#" class="btn">Všechny produkty</a></div>');


        $('.claim').appendTo('.content-wrapper-in main.content:eq(1)')
    }
};